$(document).ready(function () {
    const items = $('.header .menu__item');

    items.click(function (e) {
        if ($(window).width() > 768) return;
        if ($(e.target).hasClass('submenu__link')) return;

        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            animateHeight($(this).find('.submenu__item'));
            return;
        }

        const activeItem = items.filter((index) => items.eq(index).hasClass('active')).eq(0);
        if (activeItem.length) {
            activeItem.removeClass('active');
            animateHeight(activeItem.find('.submenu__item'));
        }
        $(this).addClass('active');
        animateHeight($(this).find('.submenu__item'), true);

    });

    const animateHeight = (element, innerHeight = false) => {
        const height = innerHeight ? element.get(0).scrollHeight : 0,
            time = innerHeight ? 330: 200;

        element.animate({
            height: height
        }, time);
    };
});